module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Bold.6aacee84.woff2";